import { render, staticRenderFns } from "./LoadingDot.vue?vue&type=template&id=4509d154&scoped=true&"
import script from "./LoadingDot.vue?vue&type=script&lang=js&"
export * from "./LoadingDot.vue?vue&type=script&lang=js&"
import style0 from "./LoadingDot.vue?vue&type=style&index=0&id=4509d154&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4509d154",
  null
  
)

export default component.exports